import "./App.css";
import MyApp from "./containers/App";

function App() {
  return <MyApp />;
}

export default App;
